import styled, { css } from 'styled-components';
import { parseTypography } from '@kueski-dev/kueski-design-system';

export const FooterContainer = styled.div`
  margin-top: 4rem;
  width: 100%;
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    margin-bottom: ${theme.spacing.spacing09}; 
    width: 100%; 


    @media ${theme.breakpoint.onlyPhone} {
      flex-direction: column;
      justify-self: start;
      align-items: start;

      margin-left: auto;
      margin-right: auto;

      width: 80vw;
    }
  `}
`;

export const SignOut = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    margin-right: ${theme.spacing.spacing06};
    ${parseTypography('Text/Label/Medium/Medium')}

    @media ${theme.breakpoint.onlyPhone} {
      margin-right: 0;
      width: 100%;
      ${parseTypography('Text/Body/Large/Medium')}

    }
  `}
`;

export const SignOutButton = styled.span`
  ${({ theme }) => css`
    color: ${theme.color.primary};
    cursor: pointer;
  `}
`;

export const Terms = styled.div`
  ${({ theme }) => css`
    ${parseTypography('Text/Label/Medium/Medium')}
    color: ${theme.color.secondaryLight};
    display: flex;
    gap: ${theme.spacing.spacing05};
    
    @media ${theme.breakpoint.onlyPhone} {
      justify-content: space-between;
      margin-top: ${theme.spacing.spacing05};
      width: 100%;
    }
  `}
`;

export const CustomLink = styled.a.attrs((props) => ({
  rel: props?.rel ?? 'noopener noreferrer',
  target: '_blank',
}))`
  ${({ theme }) => css`
    ${parseTypography('Text/Label/Medium/Medium')}
    color: ${theme.color.secondaryLight};
    text-decoration: none;
  `}
`;

export const KueskiTermsYear = styled.div`
  flex-grow: 1;
`;

export const Reca = styled.p`
  ${({ theme }) => css`
    ${parseTypography('Text/Label/Medium/Medium')}
    color: ${theme.color.secondaryLight};
    margin-bottom: ${theme.spacing.spacing09};

  `}
`;
